<script>
  export let size = 42;
</script>

<svg width={size} height={size} viewBox="0 0 47 42" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_38_5356)">
    <path
      d="M34.7723 16.6139C34.7723 16.6139 38.0494 17.2119 39.7541 21.8349C40.2413 23.1566 40.8851 24.419 41.783 25.499C42.5124 26.3674 43.462 27.265 44.6073 27.8298L37.5601 26.6426C37.5601 26.6426 36.7512 25.926 36.038 23.6577C35.7526 22.7569 35.4159 21.8746 34.9661 21.0441C34.0712 19.3919 32.4907 17.0114 30.4468 16.1921L34.7723 16.6139Z"
      fill="#FFAF50"
    />
    <path
      d="M22.3153 27.7862C22.3153 27.7862 25.4615 28.7571 28.3909 23.7281C28.6683 23.2559 28.904 22.7652 29.125 22.2643C29.7405 20.8756 31.7992 16.766 34.7723 16.6141L30.4468 16.1923C29.0945 16.0618 27.79 16.7034 27.076 17.8586C26.7332 18.4161 26.3409 19.1139 25.9311 19.9689C25.3107 21.2557 24.4669 22.44 23.3919 23.3852C21.9236 24.6719 19.7125 25.8792 16.7204 25.5527L22.3116 27.7836L22.3153 27.7862Z"
      fill="#DE871F"
    />
    <path
      d="M5.52025 19.0546C5.52025 19.0546 8.98749 12.4675 13.8364 13.055L9.46335 11.2541C8.14861 10.7124 6.65573 10.8441 5.45509 11.6024C4.12085 12.4419 2.28416 13.918 0.162109 16.4844L5.52025 19.0546Z"
      fill="#DE871F"
    />
    <path
      d="M13.8364 13.055C13.8364 13.055 15.8787 14.2889 16.6343 18.2936C17.0354 20.43 17.7482 22.5121 18.8863 24.3627C19.7681 25.7924 20.9194 27.1654 22.3153 27.7861L16.7077 26.1618C15.2028 25.7271 13.9869 24.6094 13.4388 23.1409C13.2398 22.6071 13.0469 21.9792 12.8791 21.2376C12.7361 20.601 12.6341 19.9604 12.5534 19.3129C12.3914 17.9955 11.645 13.4721 8.84504 11.06L13.8338 13.0587L13.8364 13.055Z"
      fill="#FFAF50"
    />
  </g>
  <defs>
    <clipPath id="clip0_38_5356">
      <rect
        width="20.1523"
        height="42.8818"
        fill="white"
        transform="translate(0.162109 16.4844) rotate(-54.8833)"
      />
    </clipPath>
  </defs>
</svg>
